import { faMicrophone } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useSpeechToText from './useSpeechToText';
import { Box } from '@mantine/core';
import { faMicrophoneSlash } from '@fortawesome/free-solid-svg-icons';

type VoiceCommandProps = {
  handleAskQuestion: (
    question: string,
    type: 'voice' | 'text' | 'recommended'
  ) => void;
  question: string;
  isLoading: boolean;
};

const VoiceCommand = ({
  handleAskQuestion,
  question,
  isLoading,
}: VoiceCommandProps) => {
  const { isListening, startListening, stopListening, isSpeechSupported } =
    useSpeechToText(handleAskQuestion);

  const handleListen = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isListening) {
      stopListening();
    } else if (!question.trim() && isSpeechSupported) {
      startListening();
    }
  };

  return (
    <Box
      style={{
        cursor: 'pointer',
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
      onClick={handleListen}
    >
      <FontAwesomeIcon
        icon={isListening ? faMicrophoneSlash : faMicrophone}
        style={{
          color: isListening ? 'var(--mantine-color-red-1)' : undefined,
        }}
      />
    </Box>
  );
};

export default VoiceCommand;
